import { DEFAULT_BUTTON_PROPS } from '@/constants/colors';

export const TYPE = {
  YES: 'YA',
  NO: 'TIDAK',
};

export const ERROR_TYPE = {
  name: undefined,
  email: undefined,
  phone: undefined,
  address: undefined,
};

export const ERROR_PROPS = {
  color: 'red.600',
  marginTop: '4px',
};

export const INPUT_COMMON_PROPS = {
  isRequired: true,
  size: 'md',
  type: 'text',
  variant: 'outline',
  colorScheme: 'blackAlpha',
  backgroundColor: 'white',
  color: 'mainColorText',
  fontSize: 'md',
  borderRadius: '0',
  fontFamily: 'body',
  _placeholder: { color: 'mainColorText', opacity: '.5' },
  _focus: { borderColor: 'mainColorText' },
  borderColor: 'black',
};

export const SELECT_COMMON_PROPS = {
  borderRadius: '0',
  size: 'md',
  variant: 'outline',
  backgroundColor: 'white',
  borderColor: 'black',
  color: 'mainColorText',
  fontFamily: 'body',
  fontSize: 'md',
  fontWeight: '300',
  _focus: { borderColor: 'mainColorText' },
};

export const RSVP_BUTTON_PROPS = {
  ...DEFAULT_BUTTON_PROPS,
  width: '140px',
  fontSize: '18px',
  _hover: { opacity: 0.5 },
};

export const RSVP_STATE = {
  attend: 'attend',
  info: 'info',
  confirmation: 'confirmation',
  submitted: 'submitted',
};

export const BTN_ALTERNATE = {
  backgroundColor: 'bgAlternative',
  color: 'alternativeColorText',
};

export const getStepNumber = (state) => {
  switch (state) {
    case RSVP_STATE.attend:
      return 0;
    case RSVP_STATE.info:
      return 1;
    case RSVP_STATE.confirmation:
      return 2;
    case RSVP_STATE.submitted:
      return 2;
    default:
      return 1;
  }
};
